@if (svg()) {
  <span class="msa-icon" [class]="iconClass()" [innerHTML]="safeSvg()!" [style.color]="color() || null"></span>
} @else if (name()) {
  <span class="msa-icon" [class]="iconClass()" [style.color]="color() || null">{{ name() }}</span>
}
